import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';

const FriendCountryCode = (props) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const { friendIndex, form_component } = props;

	const [countryCodes, setCountryCodes] = useState([]);
	const [selectedValue, setSelectedValue] = useState('');
	
	const fv = useSelector(state => state.fv);
	const pageData = useSelector(state => state.pageData);
	const {acct_id, controller} = pageData;

	useEffect(() => {
		loadData();
	}, []);

	const registerField = () => {
		const validator = controller === 'Shopcarts' ? window.globalFormValidator : fv;
		
		if (validator && form_component.required) {
			const fieldName = `friend[${friendIndex}][country_code]`;
			
			try {
				if (validator.elements && validator.elements[fieldName]) {
					validator.removeField(fieldName);
				}
				
				validator.addField(fieldName, {
					validators: {
						notEmpty: {
							message: t('此欄為必須填寫')
						}
					},
					selector: `select[name="${fieldName}"]`
				});
			} catch (error) {
				console.error('Error registering field:', fieldName, error);
			}
		}
	};

	useEffect(() => {
		registerField();
	}, [fv, controller, form_component.required, t, friendIndex]);

	useEffect(() => {
		const handleReinitialization = (event) => {
			registerField();
		};

		document.addEventListener('formValidationReinitialized', handleReinitialization);
		
		return () => {
			document.removeEventListener('formValidationReinitialized', handleReinitialization);
		};
	}, [fv, controller, form_component.required, t, friendIndex]);

	async function loadData() {
		try {
			let country_codes = [], default_country_code = '';

			const response = await axios.get(`/Countries/ajaxGetData/${acct_id}`);

			country_codes = response.data.country_codes;
			default_country_code = response.data.default_country_code;
			
			if (form_component?.country_code_display_option === 'specific') {
				country_codes = form_component?.country_code_options;
			}

			setCountryCodes(country_codes);
			setSelectedValue(default_country_code);
		} catch (e) {
			console.error(e);
		}
	}

	const onChange = (e) => {
		const value = e.target.value;
		setSelectedValue(value);
	}

	return (
		<select
			name={`friend[${friendIndex}][country_code]`}
			className="mw-100px form-select form-select-sm"
			id={`friend-${friendIndex}-country-code`}
			value={selectedValue}
			onChange={onChange}
		>
			{(() => {
				const components = [];
				
				countryCodes.map((countryCode, index) => {
					components.push(
						<option key={`friend-${friendIndex}-country-code-${index}`} value={countryCode}>{countryCode}</option>
					);
				})

				return components;
			})()}
		</select>
	);
}

export default FriendCountryCode;
